<template>
  <section class="world">
    <ul class="slider__list">
      <li
        class="list__item"
        v-for="text in texts"
        :key="text.title"
        :style="{
          left: `${text.left}px`,
          transform: `translate3d(${-scrollValue}px, -25%, 0)`
        }"
      >
        {{text.title}}
      </li>
    </ul>

    <div class="world__sticker"></div>

    <WorldFace />
  </section>
</template>

<script>
import gsap from 'gsap';
import loop from 'raf-loop';

import WorldFace from '@/components/WorldFace';
import { isMobile } from '@/scripts/utils';
import list from '@/assets/data/world.json';


export default {
  name: 'World',

  components: {
    WorldFace,
  },

  data() {
    return {
      list,
      texts: [],
      isMobile,
      scrollValue: 0,
      totalWidth: 0,
    };
  },

  created() {
    this.list.forEach((el) => {
      this.texts.push({
        title: el,
        left: 0,
        width: 0,
      });
    });
  },

  mounted() {
    this.$store.commit('ADD_BUTTONS', this.$el);
    gsap.set('.slider__list', { opacity: 0 });
    gsap.to('.slider__list', 0.5, {
      opacity: 1,
      delay: 0.8,
      clearProps: 'all',
    });

    // const font = new FontFaceObserver('Neutral', {
    //   weight: 500,
    // });

    this.setEls();
    this.engine = loop(this.renderer).start();

    // font.load().then(() => {
    //   this.resize();
    //   this.addEvents();

    //   this.animateInSlider();
    // }, () => {
    //   this.resize();
    //   this.addEvents();

    //   this.animateInSlider();
    // });
  },

  methods: {
    renderer() {
      this.scrollValue += 2;

      this.texts.forEach((el) => {
        if ((this.scrollValue - el.left) > el.width) {
          el.left = this.totalWidth;
          this.totalWidth = this.totalWidth + el.width;
        }
      });
    },

    setEls() {
      const nodes = Array.from(this.$el.querySelectorAll('.list__item'));
      let left = 0;
      this.totalWidth = 0;

      this.texts.forEach((el) => {
        el.node = nodes.find(node => node.innerText === el.title);
        el.left = left;
        el.width = el.node.clientWidth;

        el.node.style.left = `${left}px`;

        left += el.width;
        this.totalWidth += el.width;
      });
    },

    resize() {
      this.contW = this.$el.clientWidth;

      this.scrollTarget = null;
      this.oldScrollValue = 0;
      this.scrollValue = 0;

      this.setPos();

      this.update();
    },
  },

  beforeDestroy() {
    this.engine.stop();
    this.engine = null;
  },
};
</script>

<style lang="scss" scoped>
@import '../styles/colors';
@import '../application';

:global {
  @keyframes rotation {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
}

.world {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;

  display: flex;
  align-items: center;
  justify-content: flex-start;

  &__sticker {
    position: absolute;
    bottom: 15%;
    right: 25%;
    width: 100px;
    height: 100px;

    @include mq(sm) {
      bottom: 20%;
    }

    background-image: url('/static/vector/sticker.svg');
    background-size: 80%;
    background-position: center center;
    background-repeat: no-repeat;

    animation: rotation 5s linear infinite;

    z-index: 10;
  }
}

.slider__list {
  display: inline-block;
  position: relative;
  white-space: nowrap;
  list-style: none;

  transform: rotate(-6deg);

  .list__item {
    position: absolute;
    white-space: nowrap;
    display: block;
    padding-right: 25px;

    font-size: 4rem;
    font-weight: 500;
    -webkit-text-stroke: 2px $color-blue;
    color: transparent;
    letter-spacing: 2px;
    text-decoration: none;

    @include mq(sm) {
      font-size: 6.875rem;
      letter-spacing: 3px;
      padding-right: 45px;
    }
  }

  a {
    display: inline-block;
    position: relative;
    padding-right: 25px;

    font-size: 4rem;
    font-weight: 500;
    -webkit-text-stroke: 2px $color-blue;
    color: transparent;
    letter-spacing: 2px;
    text-decoration: none;

    @include mq(sm) {
      font-size: 6.875rem;
      letter-spacing: 3px;
      padding-right: 45px;
    }

    &::before {
      content: attr(data-hover);

      position: absolute;
      top: 0;
      left: 0;
      width: 0%;
      overflow: hidden;
      white-space: nowrap;
      color: $color-blue;
      transition: all 0.5s cubic-bezier(.17,.67,.32,.87);
    }

    @at-root .pointerevents:not(.touchevents) &:hover::before,
    .no-pointerevents.no-touchevents &:hover::before {
      width: 100%;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/World.vue